// Flervalg i lister med avkryssing.
//
// Vanlig klikk plukker én rad. Shift-klikk tar hele strekket fra forrige klikk
// til denne raden, slik lister ellers oppfører seg - uten det må man klikke
// tjue ganger for å velge tjue bilag.
//
// Strekket følger ankeret: var raden man startet på valgt, legges strekket til,
// var den fjernet, fjernes strekket. Da kan shift-klikk også oppheve et utvalg,
// og ikke bare bygge det opp.
//
// Ankeret står stille ved shift-klikk. Det er samme oppførsel som i Utforsker og
// gjør at man kan justere det samme strekket flere ganger uten å begynne på nytt.

type SelectionId = string | number

type NextSelectionArgs = {
  ids?: SelectionId[]
  selected?: SelectionId[]
  anchorId?: SelectionId | null
  targetId?: SelectionId | null
  extend?: boolean
}

type NextSelectionResult = {
  selected: SelectionId[]
  anchorId: SelectionId | null
}

;(function initListSelection(global: typeof globalThis) {
  const list = (value: unknown): SelectionId[] => (Array.isArray(value) ? value : [])

  const nextSelection = ({ ids, selected, anchorId, targetId, extend }: NextSelectionArgs = {}): NextSelectionResult => {
    const order = list(ids)
    const current = list(selected)
    if (targetId == null) return { selected: current, anchorId: anchorId || null }

    const from = order.indexOf(anchorId as SelectionId)
    const to = order.indexOf(targetId)
    if (extend && anchorId && anchorId !== targetId && from >= 0 && to >= 0) {
      const range = order.slice(Math.min(from, to), Math.max(from, to) + 1)
      const adding = current.includes(anchorId as SelectionId)
      const selection = adding
        ? [...current, ...range.filter((id) => !current.includes(id))]
        : current.filter((id) => !range.includes(id))
      return { selected: selection, anchorId }
    }

    const selection = current.includes(targetId)
      ? current.filter((id) => id !== targetId)
      : [...current, targetId]
    return { selected: selection, anchorId: targetId }
  }

  // Shift-klikk markerer tekst i nettleseren. I en liste man bare krysser av i
  // ser den blå markeringen ut som en feil, så den ryddes bort.
  const clearTextSelection = (): void => {
    const selection = global.getSelection && global.getSelection()
    if (selection && typeof selection.removeAllRanges === 'function') selection.removeAllRanges()
  }

  const isExtendClick = (event?: { shiftKey?: boolean } | null): boolean => Boolean(event && event.shiftKey)
  const isPickClick = (event?: { ctrlKey?: boolean; metaKey?: boolean } | null): boolean =>
    Boolean(event && (event.ctrlKey || event.metaKey))

  ;(global as any).PlummeListSelection = {
    nextSelection,
    clearTextSelection,
    isExtendClick,
    isPickClick,
  }
})(typeof window !== 'undefined' ? window : globalThis)
